import React from 'react';
// import { WIDTH_1024, WIDTH_640 } from '../../../../util/imageUtils';
import DOMPurify from 'dompurify';
import FixedPoster from './util/FixedPoster';

import './../scss/MessageWidget.scss';

const MessageWidget = (props = {}) => {
	const id = props.id || '',
		widget = props.data || {},
		data = widget.data || {},
		meta = widget.meta || {},
		titleMeta = meta.title || {},
		titleMetaCanShow = titleMeta.canShow !== undefined ? titleMeta.canShow : "true" ,
		thumbnails = meta.thumbnails || {},
		canShowImage = thumbnails.canShow || false,
		title = data.title || '',
		message = data.message || '',
		thumbnail = data.thumbnails || {},
		cardRatio = meta.card_ratio || '16x9',
		addClass = (props.type === 'NotFound') ? ' list' : '';

	return (
		<div id={id} className={'v-widget message-widget container clearfix' + addClass}>
			{titleMetaCanShow  && <h2 className="text-center widget-title">{title}</h2>}
			{canShowImage && <div className="message-poster col-lg-7 col-12">
				<FixedPoster
					className="poster-img-wrpr"
					thumbnails={thumbnail || {}}
					ratio={cardRatio}
					title={title}
				/>
			</div>}
			<div className=''>
				<div className='html-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message, {ADD_TAGS: ["iframe"], ADD_ATTR: ['target','allow', 'allowfullscreen', 'frameborder', 'scrolling'] }) }} />
			</div>
		</div>
	);
};

export default MessageWidget;
